<header id="header">
    <div class="header-wrapper">
        <img src="/assets/img/logo.jpg" class="logo" alt="{{ 'alt.logoRegion' | translate }}" />
        <h1 translate>siteTitle</h1>
        <p class="description" translate>siteIntro</p>
    </div>
</header>
